import { render, staticRenderFns } from "./ResumeProcess.vue?vue&type=template&id=57bc18a7"
import script from "./ResumeProcess.vue?vue&type=script&lang=js"
export * from "./ResumeProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports